import { DataProviderInstance } from '../../api/DataProvider';

/**
 * Etapas ativas da empresa (CompanyConfig.AppointmentSteps). Chegam junto com a
 * empresa (get_company.php); empresa sem etapas recebe lista vazia e a agenda
 * não mostra nada de etapas.
 */
export default function useAppointmentSteps() {
    const { CompanyConfig } = DataProviderInstance();
    return CompanyConfig?.AppointmentSteps;
}
